/**
 * The first value that is neither nullish nor an empty string.
 *
 * HS-840 introduced this while adopting `@typescript-eslint/prefer-nullish-coalescing`.
 * The display fallbacks it replaces were written as `name || id || ''`, which the rule
 * flags because `??` is *usually* what a `||` on a nullable value means. Here it is not:
 * the backend returns `""` for an unset name as often as it returns `null`, so switching
 * to `??` would render a blank cell where the identifier used to show. Rather than relax
 * the rule or repeat a ternary at every call site, the intent gets a name.
 *
 * Whitespace-only strings count as empty — a name of `" "` is not a name.
 *
 * @returns the first non-empty value, or `''` when every candidate is empty.
 */
export function firstNonEmpty(...values: (string | null | undefined)[]): string {
  for (const value of values) {
    if (value != null && value.trim() !== '') return value;
  }
  return '';
}
